var map = {
	"./crocword.mp4": 95460,
	"./fairy.mp4": 251666,
	"./heroes.mp4": 914553,
	"./hustlemerge.mp4": 347890,
	"./mergecraft.mp4": 968443,
	"./riddles.mp4": 190264,
	"./scramble.mp4": 923704,
	"./tripeaks.mp4": 486668,
	"./wondermerge.mp4": 570574,
	"./woodenblock.mp4": 16212,
	"./zenmatch.mp4": 147971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441496;